<template>
  <div class="home">
    <div class="splash">
      <div class="icon-label mb-3">
        <svg svg-inline="" class="icon white" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="47" height="17" viewBox="0 0 47 17"><path fill="#969696" d="M46.066 13.472c.07 1.865-1.397 3.43-3.3 3.498H16.98a.75.75 0 0 1-.63-.344L9.38 5.808a.75.75 0 0 1 .527-1.15l3.142-.438a.75.75 0 0 1 .638.217l5.784 5.885 5-.021-10.066-8.69a.75.75 0 0 1 .44-1.315l4.301-.294a.75.75 0 0 1 .464.122l15.414 10.148 7.533-.05c1.87-.062 3.441 1.39 3.51 3.25zm-3.478-1.75h-.014l-7.768.052a.75.75 0 0 1-.417-.124L18.996 1.515l-2.23.153 10.202 8.806c.525.453.207 1.315-.487 1.318l-7.32.032a.75.75 0 0 1-.538-.225l-5.74-5.84-1.606.223 6.112 9.488h25.35a1.885 1.885 0 0 0 1.828-1.943 1.89 1.89 0 0 0-1.979-1.805zM11.581 15.47a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1 0-1.5h10.831zm-3.84-3.829c.414 0 .75.224.75.5s-.336.5-.75.5H.75c-.414 0-.75-.224-.75-.5s.336-.5.75-.5h6.991z"/></svg>
      </div>
      <h1 class="mb-2">
        Request tattooers
        <br v-if="$root.isMobile"/>
        to come to your city.
      </h1>
      <p>Get notified when they’re coming.</p>
    </div>

    <b-row>
      <b-col lg="8">
        <div class="filtering">
          <SearchArtist id="searchArtist"/>

          <div class="filtering-buttons">
            <b-button
              v-for="button in orders"
              :key="button.key"
              :variant="buttonVariant(button.key)"
              @click="orderBy(button.key, button.type)"
              class="small"
            >
              {{ button.label }}
            </b-button>
          </div>
        </div>

        <Artist
          v-for="artist in filteredArtists"
          :key="getArtistKey(artist.id)"
          :id="artist.id"
          :place="artist.place"
          :name="artist.name"
          :handle="artist.handle"
          :requests="artist.requestsCount"
          @click.native="redirect(artist.handle)"
          class="artist"
        ></Artist>
      </b-col>
      <b-col>
        <div class="share-container">
          <ShareWithArtist class="share"/>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Artist from '../components/Artist.vue';
import SearchArtist from '../components/SearchArtist.vue';
import ShareWithArtist from '../components/ShareWithArtist.vue';

export default {
  name: 'home',
  mounted() {
  },
  components: {
    Artist,
    SearchArtist,
    ShareWithArtist,
  },
  data() {
    return {
      orders: [
        {
          label: 'Last requested',
          key: 'last_request_on',
          type: 'Last Requested',
        },
        {
          label: 'A-Z',
          key: 'name',
          type: 'Alphabetical',
        },
      ],
    };
  },
  computed: {
    filteredArtists() {
      if (this.$store.getters.search !== '') {
        return this.artists;
      }

      if (this.$store.getters.orderBy === 'last_request_on') {
        return this.artists.slice(0, 50);
      }

      if (this.$store.getters.orderBy === 'name') {
        return this.artists.filter(artist => artist.requestsCount > 0);
      }

      return this.artists;
    },
    ...mapGetters(['artists']),
  },
  methods: {
    getArtistKey(id) {
      return this.$store.getters.loading ? `loading-${id}` : `loaded-${id}`;
    },
    buttonVariant(button) {
      return this.$store.getters.orderBy === button ? 'coal-primary' : 'coal-secondary';
    },
    orderBy(order, type) {
      if (order !== this.$store.getters.orderBy) {
        this.$store.commit('orderBy', order);

        window.scrollTo({
          top: document.getElementsByClassName('artist')[0].offsetTop - document.getElementsByClassName('artist')[0].offsetHeight,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    redirect(handle) {
      this.$router.push({ name: 'artist', params: { handle } });
    },
    ...mapActions(['auth', 'fetchArtists', 'fetchPlaces', 'fetchArtistVariables']),
  },
  created() {
    this.$store.commit('loading', true);

    this.fetchPlaces().then(() => {
      this.fetchArtists().then(() => {
        const artists = [];
        const keys = Object.keys(this.artists);
        const count = keys.length;
        let i = 0;

        keys.forEach((key) => {
          const artist = this.artists[key];
          this.fetchArtistVariables(artist.id)
            .then((varResponse) => {
              i += 1;

              Object.assign(
                this.artists[key],
                varResponse.val() || this.$store.getters.defaultArtistVar,
              );

              artists.push(this.artists[key]);

              // Ugly "hack"
              if (i === count) {
                this.$store.commit('artists', artists);
                this.$store.commit('loading', false);
              }
            });
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .splash {
    background-size: cover !important;
    margin: 0 -$side-margin;
  }

  .desktop .splash {
    background: none;
    padding: 60px $side-margin 50px;

    p {
      color: #787878;
      font-family: $font-sans-serif-reg;
    }
  }

  .mobile .splash {
    background: transparent url('/splash.png') no-repeat;
    margin-bottom: 30px;
    padding: 60px $side-margin 20px;

    p {
      color: $dark-white;
    }
  }

  button:first-of-type {
    margin-right: 16px;
  }

  .sortBy {
    margin-top: 20px;
  }

  .filtering {
    margin-bottom: 8px;
    position: sticky;
    display: flex;
    justify-content: space-between;
    top: 60px;
    align-items: center;
    z-index: 99999;
    padding: 18px 0 20px;
    background-color: $black;
  }

  .filtering-buttons {
    margin-left: auto;
  }

  .artist {
    border-bottom: 1px solid #282828;
    padding: 25px 0 25px;
    cursor: pointer;
  }

  .desktop {
    .home {
      margin-top: -60px;
    }
    .filtering {
      top: 100px;
    }

    .share-container {
      position: sticky;
      right: 0;
      top: 293px;
      margin-top: 20px;
      z-index: 99999;
    }

    .share {
      position: absolute;
      right: 0;
    }

    .splash {
      background-color: #000;
      position: sticky;
      top: 85px;
      z-index: 9999;
    }

    .filtering {
      position: sticky;
      top: 273px;
      z-index: 9999;
    }
  }

  .mobile .share {
    margin-top: 30px;
  }
</style>
